(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-price-slider"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
  const slider = $("#price-slider");
  const minPriceSpan = $("#min-price");
  const maxPriceSpan = $("#max-price");

  const min = parseFloat(slider.data("min")) || 0;
  const max = parseFloat(slider.data("max")) || 400;
  const rangeMax = parseFloat($(".price-filter").data("range-max")) || 400;

  slider.slider({
    range: true,
    min: 0,
    max: rangeMax,
    values: [min, max],
    slide: function (event, ui) {
      minPriceSpan.text(ui.values[0]);
      maxPriceSpan.text(ui.values[1]);
    },
    change: function (event, ui) {
      const url = new URL(window.location);
      url.searchParams.set("filter.v.price.gte", ui.values[0]);
      url.searchParams.set("filter.v.price.lte", ui.values[1]);
      window.location = url;
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  var now = new Date();
  var dayNr = now.getDay();
  var hour = now.getHours();

  // Werkdagen: maandag (1) t/m vrijdag (5)
  var showDays = [1, 2, 3, 4, 5];
  var showCountdownFrom = 0;
  var showCountdownTill = 20; // Eindtijd: 20:00

  // Alleen tonen op werkdag en binnen tijdsperiode
  if (showDays.includes(dayNr) && hour >= showCountdownFrom && hour < showCountdownTill) {
    var countdownEl = document.querySelector('.order-countdown .countdown');
    var timeEl = document.querySelector('.order-countdown .countdown .time');

    if (countdownEl && timeEl) {
      console.log('aa')
      countdownEl.classList.remove('hidden');

      var target = new Date();
      target.setHours(showCountdownTill, 0, 0, 0); // tot 20:00:00

      function updateCountdown() {
        var now = new Date();
        var remaining = target - now;

        if (remaining <= 0) {
          countdownEl.classList.add('hidden');
          return;
        }

        var hours = Math.floor(remaining / (1000 * 60 * 60));
        var minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((remaining % (1000 * 60)) / 1000);

        // Format naar 00:00:00
        var formatted = 
          (hours < 10 ? '0' : '') + hours + ':' +
          (minutes < 10 ? '0' : '') + minutes + ':' +
          (seconds < 10 ? '0' : '') + seconds;

        timeEl.textContent = formatted;
        requestAnimationFrame(updateCountdown); // update soepel via requestAnimationFrame
      }

      updateCountdown();
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
